module.exports = __webpack_public_path__ + "img/left-arrow.9e9c692f.svg";